"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const new_item_1 = __importDefault(require("./new-item"));
class NewRequestSecret extends new_item_1.default {
    constructor(newRequestSecret) {
        super();
        this.applicationId = newRequestSecret.applicationId;
        this.password = newRequestSecret.password;
        this.clientSecret = newRequestSecret.clientSecret;
    }
}
exports.default = NewRequestSecret;
//# sourceMappingURL=new-requestSecret.js.map